var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.5L1.18609 8.56141C-0.395364 6.94604 -0.395364 4.33442 1.18609 2.71905C2.77736 1.09365 5.36477 1.09365 6.95604 2.71905L7 2.76395L7.04396 2.71905C8.63523 1.09365 11.2226 1.09365 12.8139 2.71905C14.3954 4.33442 14.3954 6.94604 12.8139 8.56141L7 14.5ZM7 5.64023L5.53553 4.14435C4.72673 3.31821 3.4154 3.31821 2.6066 4.14435C1.7978 4.9705 1.7978 6.30995 2.6066 7.1361L7 11.6237L11.3934 7.1361C12.2022 6.30995 12.2022 4.9705 11.3934 4.14435C10.5846 3.31821 9.27327 3.31821 8.46447 4.14435L7 5.64023Z",
    fill: "#212D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d712f8595d24baa0238494947beebf2a.svg";
export { ForwardRef as ReactComponent };